import { GenericSBProps } from '../types';
import FalconButtonV2 from '../FalconButtonV2/FalconButtonV2';
import RichText, { RichTextSchema } from '../richtext';
import ToolTip from '../ToolTip/ToolTip';
import Styles from './GenericMessage.module.scss';
import React,{ useState,JSX } from 'react';
// import ContactRequestCallback from '../ContactRequestCallback/ContactRequestCallback';
import { CURRENCY, GAEVENT, GENERATELEAD } from '../../Analytics/AnalyticsConstants';
import { trackNewDatalayerEvent } from '../../utils/AnalyticsUtils';

export interface MessageContentSchema extends GenericSBProps {
  title: string;
  description: RichTextSchema | string;
  toolTipText?: RichTextSchema;
}
export interface GenericMessageSchema {
  content: any;
  status: string;
  outerClass?: string;
  icon?: '' | 'message' | 'send' | 'warning' | 'tip';
}

const GenericMessage = ({
  content,
  status,
  outerClass = '',
  icon = ''
}: GenericMessageSchema): JSX.Element => {
  const [isCallbackShown, setIsCallbackShown] = useState(false);
  const handleClick = () => {
    setIsCallbackShown(false);
  };

  const submitForm = () => {
    trackNewDatalayerEvent(GAEVENT, GENERATELEAD, {
      currency: CURRENCY,
      form_name: 'Error Popup - ' + content?.button?.[1]?.buttonLabel,
      value: 0
    });
  };
  return (
    <div className={`${Styles.messageContainer} ${Styles[status]} ${outerClass}`}>
      <div className={`${Styles.iconMessage} ${Styles[icon || status]}`} />
      <div>
        {content.title && (
          <h4 className='mb-2 d-flex'>
            <span>
              {content.title}
              {content?.toolTipText?.content?.[0]?.content && (
                <ToolTip
                  content={<RichText content={content.toolTipText} />}
                  className={Styles.tooltipSize}
                />
              )}
            </span>
          </h4>
        )}
        {typeof content.description == 'string' ? (
          content.description
        ) : (
          <RichText content={content.description}></RichText>
        )}
        {content?.button?.[0] && <FalconButtonV2 content={content?.button?.[0]} className='p-0' />}

        {content?.button?.[1] && (
          <>
            <span className={Styles.callmebtn}> or </span>
            <span>
              <FalconButtonV2
                content={content?.button?.[1]}
                className='p-0'
                onClick={() => {
                  setIsCallbackShown(true);
                }}
              />
            </span>
          </>
        )}
      </div>

     {/** {isCallbackShown && content?.contactRequestCallback?.[0] && (
        <ContactRequestCallback
          content={{
            ...content.contactRequestCallback?.[0],
            setClicked: handleClick,
            submitForm: submitForm
          }}
        />
      )}*/ }
    </div>
  );
};

export default GenericMessage;
